import type { ArtistProfileResponse } from 'fym-shared/src/music24/artistProfile';
import { profileSlotOf } from '../profileSlots';

/**
 * "In your profile" of the kit Spotify header slot (design c3): the current Profile header came from
 * this release, and from this slot's file (`kitAssetUuid`) or from the blurred cover of this release
 * ("Use this release for my profile" sends no kit asset). Pure.
 */
export function headerIsInProfile(
  assets: ArtistProfileResponse['assets'] | undefined,
  catalogItemUuid: string,
  kitAssetUuids: readonly string[]
): boolean {
  const { current } = profileSlotOf(assets, 'spotifyHeader');
  if (current === null || current.catalogItemUuid !== catalogItemUuid) {
    return false;
  }
  if (current.kitAssetUuid !== null) {
    return kitAssetUuids.includes(current.kitAssetUuid);
  }
  return current.source === 'cover';
}
